<template>
  <div class="AdminUserEdit">
    <div class="Toolbar">
      <div class="Toolbar-Left cursorPointer" @click="_onClickGoBack">
        <font-awesome-icon :icon="['fal', 'angle-left']" size="2x" />
        <span class="u-ml10 TextWithIcon name-bold">
          {{ clientGroup.name }}
        </span>
      </div>
    </div>

    <el-row :gutter="20">
      <el-col :span="14" :offset="2">
        <h2>ユーザー情報の編集</h2>
      </el-col>
      <el-col :span="14" :offset="2">
        <!-- Forms -->
        <el-form :model="userEditForm" ref="userEditForm" label-width="130px">
          <!-- Name Form -->
          <el-form-item
            label="お名前"
            prop="name"
            :rules="[
              {
                required: true,
                message: 'お名前は必須の項目です',
                trigger: 'blur'
              }
            ]"
          >
            <el-input
              placeholder="お名前"
              v-model="userEditForm.name"
              class="e-input"
            ></el-input>
          </el-form-item>

          <!-- Role Form -->
          <el-form-item
            label="権限"
            prop="role"
            :rules="[{ required: true, message: '権限は必須の項目です' }]"
          >
            <el-radio-group v-model="userEditForm.role">
              <el-radio label="CLIENT_USER">通常</el-radio>
              <el-radio label="CLIENT_CONTRIBUTOR">制限あり</el-radio>
            </el-radio-group>
            <div class="notice-text">
              ※制限あり ‥
              注文送信ができません。作成した注文の内容確認を通常ユーザーに出すことができます。
            </div>
          </el-form-item>

          <!-- Email Form -->
          <el-form-item
            label="メールアドレス"
            prop="email"
            :rules="[
              {
                required: true,
                message: 'メールアドレスは必須の項目です',
                trigger: 'blur'
              },
              {
                type: 'email',
                message: 'メールアドレス形式のみ入力してください',
                trigger: 'blur'
              },
              {
                pattern: /^[ A-Za-z0-9-./@_]*$/,
                message: '半角英数字のみ入力してください',
                trigger: 'blur'
              }
            ]"
          >
            <el-input
              placeholder="xxx@xxx.com"
              v-model="userEditForm.email"
              class="e-input"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-for="(group, index) in userEditForm.clientGroups"
            :label="'得意先コード' + (index + 1)"
            :key="group.key"
            :prop="'clientGroup' + index"
          >
            <el-input
              v-model="group.id"
              style="width: 70%; margin-right: 5px;"
            ></el-input
            ><el-button
              v-if="index > 0"
              @click.prevent="removeClientGroupInput(index)"
              >削除</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button @click="addClientGroupInput"
              >得意先コードを追加</el-button
            >
          </el-form-item>

          <!-- Actions -->
          <el-form-item>
            <div class="u-flex">
              <div class="u-flex u-grow">
                <el-button @click="getCancelUpdateUserDialog()"
                  >キャンセル</el-button
                >
              </div>
              <div class="u-flex u-grow u-jce">
                <el-button type="primary" @click="getUpdateUserDialog()"
                  >保存</el-button
                >
              </div>
            </div>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <!-- Dialogs Division -->
    <div class="UserEditDialog">
      <!-- edit user dialog -->
      <el-dialog :visible.sync="editUserDialogVisible" center>
        <span class="dialog-text">編集した内容を保存しますか？</span>
        <span slot="footer" class="dialog-footer">
          <el-button class="cancel-btn" @click="editUserDialogVisible = false"
            >キャンセル</el-button
          >
          <el-button @click="_onClickUpdateUser()" class="blue-text-edit"
            >はい</el-button
          >
        </span>
      </el-dialog>
      <!-- cancel edit user dialog -->
      <el-dialog :visible.sync="cancelUpdateUserDialogVisible" center>
        <span class="dialog-text">編集を中止しますか？</span>
        <span slot="footer" class="dialog-footer">
          <el-button
            class="cancel-btn"
            @click="cancelUpdateUserDialogVisible = false"
            >キャンセル</el-button
          >
          <el-button @click="_onClickCancelUpdateUser()" class="blue-text-edit"
            >はい</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// Usecase Dependencies
import { mapState } from "vuex";
import UserUsecase from "@/usecases/user.usecase";

export default {
  components: {},
  data () {
    return {
      userUsecase: new UserUsecase(),
      userEditForm: {
        name: "",
        role: "",
        clientGroups: [],
        email: "",
      },
      editUserDialogVisible: false,
      cancelUpdateUserDialogVisible: false,
    };
  },
  async created () {
    this.getUserInfo();
  },
  computed: {
    ...mapState({
      clientGroup: state => state.user.clientsGroup,
      userId: state => state.user.userId,
    }),
  },
  watch: {},
  methods: {
    /* to get user by user id */
    async getUserInfo () {
      const user = await this.userUsecase.getUser({ userId: this.userId });
      this.userEditForm = {
        name: user.name,
        role: user.role,
        clientGroups: user.clientGroups.map(c => {
          return {
            key: Date.now(),
            id: c.id,
          };
        }),
        email: user.email,
      };
    },
    /* to open create user dialog */
    getUpdateUserDialog () {
      this.$refs["userEditForm"].validate(valid => {
        if (valid) {
          this.editUserDialogVisible = true;
        }
      });
    },
    /* to open cancel create user dialog */
    getCancelUpdateUserDialog () {
      this.cancelUpdateUserDialogVisible = true;
    },
    /* to on click update user */
    async _onClickUpdateUser () {
      var message = "";
      let clientGroupID = this.clientGroup.id;
      const loading = this.$loading();
      try {
        // update it
        await this.updateUserInfos();

        // it succeed, so I notify it
        message = "編集内容を保存しました。";
        this.$notify({ message });

        // transition to client list
        this.$router.push({
          name: "admin/clients/users",
          params: { clientGroupID },
        });
      } catch (err) {
        alert(err.errors[0].message);
        return;
      } finally {
        loading.close();
      }
    },
    /* to update user, save user update information */
    async updateUserInfos () {
      const userUpdateParam = {
        userId: this.userId,
        user: {
          name: this.userEditForm.name,
          role: this.userEditForm.role,
          clientGroupIds: this.userEditForm.clientGroups.map(c => c.id),
          email: this.userEditForm.email,
        },
      };
      const res = await this.userUsecase.updateUser(userUpdateParam);

      return res;
    },
    /* to cancel create user go back to client list */
    _onClickCancelUpdateUser () {
      this.goBack();
    },
    _onClickGoBack () {
      this.goBack();
    },
    goBack () {
      const { $router } = this;
      const clientID = this.clientGroup.id;
      $router.push({ name: "admin/clients/users", params: { clientID } });
    },
    removeClientGroupInput (index) {
      if (this.userEditForm.clientGroups.length > 1) {
        this.userEditForm.clientGroups.splice(index, 1);
      }
    },
    addClientGroupInput () {
      this.userEditForm.clientGroups.push({
        key: Date.now(),
        id: "",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.AdminUserEdit .Toolbar {
  display: flex;
  align-items: center;
  padding: 10px;
  margin-left: 1rem;
}
.AdminUserEdit .Toolbar-Left {
  flex: 1;
  justify-content: center;
  align-items: center;
}
.AdminUserEdit .Toolbar-Center {
  flex: 1;
  justify-content: center;
  align-items: center;
}
.AdminUserEdit .Toolbar-Right {
  flex: 1;
  text-align: right;
}
</style>

<style lang="scss">
@import "~@/assets/styles/variables.scss";

.AdminUserEdit {
  width: 99%;
}
.UserEditDialog .dialog-text {
  font-size: 17px;
  font-weight: bold;
}
.UserEditDialog .el-dialog--center .el-dialog__body {
  text-align: center;
  padding-bottom: 5rem;
  padding-top: 4.5rem;
}
.UserEditDialog .el-button {
  border: none;
}
.UserEditDialog .el-dialog__close {
  display: none;
}
.UserEditDialog .blue-text-edit {
  color: $blue-extra-deep;
}
@media (min-width: 767px) {
  .UserEditDialog .el-dialog {
    width: 35% !important;
    height: 45% !important;
  }
  .UserEditDialog .el-dialog__footer {
    margin-top: -0.5rem !important;
  }
  .UserEditDialog .el-dialog--center .el-dialog__body {
    margin-top: 1rem !important;
  }
}
@media (max-width: 768px) {
  .UserEditDialog .el-dialog {
    width: 50% !important;
    height: 25% !important;
  }
  .UserEditDialog .el-dialog__footer {
    margin-top: -2rem !important;
  }
  .UserEditDialog .el-dialog--center .el-dialog__body {
    margin-top: 0rem !important;
  }
}
.UserHeaderTopRight {
  width: 500px;
  font-weight: bold;
  margin-top: 0.5rem;
  margin-left: 2rem;
}
.name-bold {
  width: 500px;
  font-weight: bold;
}
</style>
